import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import EmailFormModal from '../../../components/EmailForm/EmailFormModal';
import PreferedCard from '../../../components/PreferedCard';
import useModal from '../../../hooks/useModal';
import DeleteModal from '../../widgets/deleteModal/DeleteModal';

const EmailTabContent = ({
  workEmail,
  setWorkEmail,
  personalEmail,
  setPersonalEmail,
  isWorkEmailChecked,
  isPersonalEmailChecked,
  setIsWorkEmailChecked,
  setIsPersonalEmailChecked,
}: any) => {
  const [
    showDeletePersonalEmailModal,
    handleDeletePersonalEmailShow,
    handleDeletePersonalEmailClose,
  ] = useModal();

  const [
    showDeleteWorkEmailModal,
    handleDeleteWorkEmailShow,
    handleDeleteWorkEmailClose,
  ] = useModal();

  const [showAddNewEmailModal, handleAddNewEmailShow, handleAddNewEmailClose] =
    useModal();

  const [
    showEditWorkEmailModal,
    handleEditWorkEmailShow,
    handleEditWorkEmailClose,
  ] = useModal();

  const [
    showEditPersonalEmailModal,
    handleEditPersonalEmailShow,
    handleEditPersonalEmailClose,
  ] = useModal();

  const handleSubmitEmail = (formData: any) => {
    if (formData.type === 'personal') {
      setPersonalEmail(formData);
    } else {
      setWorkEmail(formData);
    }

    handleAddNewEmailClose();
    handleEditWorkEmailClose();
    handleEditPersonalEmailClose();
  };

  const handleWorkEmailChecked = () => {
    setIsWorkEmailChecked(!isWorkEmailChecked);
    setIsPersonalEmailChecked(false);
  };

  const handlePersonalEmailChecked = () => {
    setIsPersonalEmailChecked(!isPersonalEmailChecked);
    setIsWorkEmailChecked(false);
  };

  return (
    <Fragment>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon variant={'icon-emphasized'} icon={light('at')} />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>My Emails</h4>
        </div>
        <div className={'d-none d-lg-block'}>
          <Button
            size={'sm'}
            rightIcon={light('circle-plus')}
            onMouseDown={handleAddNewEmailShow}
          >
            Add new
          </Button>
          <EmailFormModal
            showModal={showAddNewEmailModal}
            handleClose={handleAddNewEmailClose}
            handleSubmit={handleSubmitEmail}
          />
        </div>
      </section>
      <Row className={'mt-5'}>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="em-1"
            title={'Work'}
            editButtonName={'Edit email'}
            onChange={handleWorkEmailChecked}
            onDelete={handleDeleteWorkEmailShow}
            onEdit={handleEditWorkEmailShow}
            checked={isWorkEmailChecked}
          >
            {<div className={'fw-light text-fs-6'}>{workEmail.email}</div>}
          </PreferedCard>
          <EmailFormModal
            showModal={showEditWorkEmailModal}
            handleClose={handleEditWorkEmailClose}
            handleSubmit={handleSubmitEmail}
            existingEmail={workEmail}
          />
          <DeleteModal
            showModal={showDeleteWorkEmailModal}
            handleClose={handleDeleteWorkEmailClose}
            handleSubmit={handleDeleteWorkEmailClose}
            title="Delete Email Address"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this email account?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={'Family Funds'}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {personalEmail.email}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="pc-2"
            title={'Personal'}
            editButtonName={'Edit email'}
            onChange={handlePersonalEmailChecked}
            onDelete={handleDeletePersonalEmailShow}
            onEdit={handleEditPersonalEmailShow}
            checked={isPersonalEmailChecked}
          >
            {<div className={'fw-light text-fs-6'}>{personalEmail.email}</div>}
          </PreferedCard>
          <EmailFormModal
            showModal={showEditPersonalEmailModal}
            handleClose={handleEditPersonalEmailClose}
            handleSubmit={handleSubmitEmail}
            existingEmail={personalEmail}
          />
          <DeleteModal
            showModal={showDeletePersonalEmailModal}
            handleClose={handleDeletePersonalEmailClose}
            handleSubmit={handleDeletePersonalEmailClose}
            title="Delete Email Address"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this email account?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={'Family Funds'}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {workEmail.email}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
      </Row>
      <div className={'w-100 mt-7 d-flex flex-column d-lg-none'}>
        <Button
          variant={'primary-outline'}
          rightIcon={light('circle-plus')}
          onMouseDown={handleAddNewEmailShow}
        >
          Add new
        </Button>
      </div>
    </Fragment>
  );
};

export default EmailTabContent;
